// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3FK0j","disabled":"FileBtn_disabled__3mrbx","warn":"FileBtn_warn__31rKP","fade":"FileBtn_fade__tzr8M"};